import { useEffect, useState } from "react";
import TeacherStudentSettingsHeader from "../../components/TeacherStudentSettingsHeader/TeacherStudentSettingsHeader";
import './StudentProfile.scss';
import { useAppSelector } from "../../redux/app/hooks";
import StudentProfileForm from "../../components/StudentProfileForm/StudentProfileForm";
import { logout, setAdminProfile, setAdminProfileImage } from "../../redux/slices/authSlice";
import Loader from "../../components/Loader/Loader";
import { useDispatch } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import { GET_CURRENT_USER } from "../AdminDashboard/api/AdminDashboardQuery";
import ToasterWithMessage from "../../components/toaster";
import images from "../../assets/images";
import { SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from "../../utils/constants";

const StudentProfile = () => {

    const [isEdit, setIsEdit] = useState<boolean>(false);
    const profile = useAppSelector((state) => state.auth.adminProfile?.getCurrentUser?.nodes?.[0]);
    const [isSubmit, setIsSubmit] = useState<boolean>(false);  
    const dispatch = useDispatch();  
    const {error} = ToasterWithMessage()
    const { schoolProfileImage } = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const { role } = useAppSelector((state) => state.auth);
    
    const handleClick = () => {
        setIsEdit(true);
        if (isEdit) {
            setIsSubmit(!isSubmit);
        }
    }

    const [getCurrentUser] = useLazyQuery(GET_CURRENT_USER, {
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        if (data && data?.getCurrentUser) {
          dispatch(setAdminProfile({ profile: data }));
          dispatch(setAdminProfileImage({ adminProfileImage: role === SCHOOL_ADMIN ? data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl : schoolProfileImage : data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
        } else {
          error("User Not Found!");
        }
      },
      onError: (err) => {
        error(err?.message);
        dispatch(logout());
      },
    });

    useEffect(() => {
      getCurrentUser({});
    }, []);

    return (
        <div className="studentProfile">
            <div className="studentProfileHeader">
                <TeacherStudentSettingsHeader
                    title="My Profile"
                    subTitle="Add Profile image to your person details"
                />
                <div className="ctaActions">
                    <button className="editBtnStyle" onClick={handleClick}>{isEdit ? "Save" : "Edit"}</button>
                </div>
            </div>
            <div className="FormContainer">
                {(profile === undefined) ? <Loader /> : (
                    <StudentProfileForm 
                        id={role === STUDENT_ROLE ? profile?.studentsByUId?.nodes?.[0]?.sId : profile?.teachersByUId?.nodes?.[0]?.tId}
                        fullName={profile?.uFullName}
                        username={profile?.uUserName}
                        password={profile?.uUserPassword}
                        phonenumber={profile?.uPhoneNumber}
                        email={profile?.uEmailId} 
                        avatarUrl={role === TEACHER_ROLE ? profile?.teachersByUId?.nodes?.[0]?.tAvatarUrl : profile?.studentsByUId?.nodes?.[0]?.sAvatarUrl} 
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        isSubmit={isSubmit}
                    />
                )}
            </div>
        </div>
    )
}

export default StudentProfile;
